import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import { useDispatch } from 'react-redux';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Pages***** */
const Dashboard = Loadable(lazy(() => import('../views/dashboard/DashboardPage')))
const AdsPage = Loadable(lazy(() => import('../views/ads/AdsPage')))
const InvoicePage = Loadable(lazy(() => import('../views/invoice/InvoicePage')))
const InsightsPage = Loadable(lazy(() => import('../views/insights/InsightsPage')))
const ProfilePage = Loadable(lazy(() => import('../views/profile/ProfilePage')))
const Error = Loadable(lazy(() => import('../views/authentication/ErrorPage')));
const Login = Loadable(lazy(() => import('../views/authentication/LoginPage')));
const Logout = () => {
  const dispatch = useDispatch()
  dispatch({ type: 'LOGOUT' })
  return <Navigate to="/auth/login"></Navigate>
}

const Router = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', element: <Navigate to="/dashboard" /> },
      { path: '/dashboard', exact: true, element: <Dashboard /> },
      { path: '/ads', exact: true, element: <AdsPage /> },
      { path: '/invoice', exact: true, element: <InvoicePage /> },
      { path: '/insights', exact: true, element: <InsightsPage /> },
      { path: '/profile', exact: true, element: <ProfilePage /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '/auth/login', element: <Login /> },
      { path: '/auth/logout', element: <Logout /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
